import { render, staticRenderFns } from "./ViewPostInteract.vue?vue&type=template&id=7e86a3c1&"
import script from "./ViewPostInteract.vue?vue&type=script&lang=js&"
export * from "./ViewPostInteract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports